module.exports = __webpack_public_path__ + "static/media/021 - MEDICAL RECORD loading.d692d57c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/021 - MEDICAL RECORD loading.png
// module id = 519
// module chunks = 0